// Car Connections scoring. Players get MAX_MISTAKES wrong guesses and may spend
// up to MAX_HINTS hints (each reveals one unsolved group's theme).
//
//   base score  = 9 - mistakes              → 9 8 7 6 5 4 3 for 0..6 mistakes
//                                              (a clean loss is 6 mistakes → 3)
//   hint cost   = triangular: 1st -1, 2nd -2, 3rd -3  → cumulative 0 / 1 / 3 / 6
//   final score = max(0, base - hintCost)            → 0..9
//
// The server is the source of truth (POST /result). Keep this file identical to
// apps/game/src/connections/score.ts.
export const MAX_MISTAKES = 6;
export const MAX_HINTS = 3;

export function baseScore(mistakes: number): number {
  const m = Math.min(Math.max(Math.trunc(mistakes), 0), MAX_MISTAKES);
  return 9 - m;
}

// 1st hint -1, 2nd -2, 3rd -3 → cumulative cost 0 / 1 / 3 / 6 (triangular).
export function hintCost(hints: number): number {
  const h = Math.min(Math.max(Math.trunc(hints), 0), MAX_HINTS);
  return (h * (h + 1)) / 2;
}

export function finalScore(mistakes: number, hints: number): number {
  return Math.max(0, baseScore(mistakes) - hintCost(hints));
}

// The next hint's incremental cost (what -N to show on the button). 0 if maxed.
export function nextHintCost(hintsUsed: number): number {
  return hintsUsed < MAX_HINTS ? hintsUsed + 1 : 0;
}

// Distinct score values, high → low, for the distribution histogram.
export const SCORE_BUCKETS = [9, 8, 7, 6, 5, 4, 3, 2, 1, 0] as const;
